import { render, staticRenderFns } from "./identicon.vue?vue&type=template&id=7a16f00b&"
import script from "./identicon.vue?vue&type=script&lang=js&"
export * from "./identicon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports